import React from 'react';
import { makeStyles, Typography, Modal, Card, CardHeader, CardContent, CardActions, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
    modal: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        outline: 'none',
        boxShadow: theme.shadows[20],
        width: 800,
        maxHeight: '100%',
        overflowY: 'auto',
        borderRadius: 10,
        [theme.breakpoints.down('xs')]: {
        width: '93%',
        },
    },
    closeIcon: {
        position: 'absolute',
        right: theme.spacing(3),
        top: 22,
        cursor: 'pointer',
        width: theme.spacing(4),
        height: theme.spacing(4),

        fill: 'white',

        '& path': {
            fill: 'white',
        },
    },
    actions: {
        marginBottom: theme.spacing(1),
        justifyContent: 'center'
    },
    header: {
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
        display: 'flex',
        backgroundColor: theme.palette.app.primary
    },
    headertitle: {
        fontSize: 16,
        color: 'white',
        fontWeight: 'bold',
        lineHeight: '40px',
        marginRight: theme.spacing(2)
    },
}));

const CommonModal = ({ open, onClose, title, children, buttonLabel, btnDisabled, onSubmit, hideClose }) => {
    const classes = useStyles();
    const renderHeader = () => {
        return (
            <div className={classes.header}>
                <div>
                    <Typography className={classes.headertitle}>{title}</Typography>
                </div>
                {!hideClose && <CloseIcon className={classes.closeIcon} onClick={onClose} />}
            </div>
        )
    }
    return (
        <Modal open={open} onClose={hideClose ? undefined : onClose}>
            <Card className={classes.modal}>
                <CardHeader
                    component={renderHeader}
                />
                <CardContent>
                    {children}
                </CardContent>
                <CardActions className={classes.actions}>
                    <Button
                        variant="contained"
                        onClick={onSubmit}
                        style={{ borderRadius: 100 }}
                        disabled={btnDisabled}
                    >
                        {buttonLabel}
                    </Button>
                </CardActions>
            </Card>
        </Modal>
    );
};
CommonModal.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    title: PropTypes.string,
    children: PropTypes.any,
    buttonLabel: PropTypes.string,
    btnDisabled: PropTypes.bool,
    onSubmit: PropTypes.func,
    hideClose: PropTypes.bool
};
export default CommonModal;


